import { createSelector } from 'reselect';

const databaseConfig = state => state.firebase.databaseConfig;
const database = state => state.firebase.database;
const storage = state => state.firebase.storage;

export const selectDatabaseConfig = createSelector(databaseConfig, databaseConfig => databaseConfig);
export const selectDatabase = createSelector(database, database => database);
export const selectStorage = createSelector(storage, storage => storage);
